import { TIMEZONES } from '@/app/dev/fixtures/timezones';
import { env } from '../utils/env';

// --- API Keys ---

export const NOTE_EDITOR_API_KEY = `${env.TINYMCE_API_KEY}`;

// --- Third Party Integrations ---

export const JITSI_APP_ID = `${env.JITSI_APP_ID}`;

// --- Storage Keys ---

// WHY: single source for the auth-token localStorage key. The literal is legacy and must not
// change — existing sessions store the token under this exact key.
export const STORAGE_KEY_TOKEN = 'LOCELLE:token';

// --- Shared Data ---

export { TIMEZONES };
